import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-language-global-icon',
    styleUrls: ['./language-global-icon.component.scss'],
    templateUrl: './language-global-icon.component.html',
    standalone: false
})
export class LanguageGlobalIconComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

}
